const BACKEND_BASE = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8000';

export interface ApiTokenInfo {
  id: string;
  name: string;
  prefix: string;
  created_at: string | null;
  last_used_at: string | null;
  revoked: boolean;
}

export interface CreateTokenResponse {
  token: string;
  id: string;
  name: string;
  prefix: string;
}

export const tokenService = {
  create: async (name: string): Promise<CreateTokenResponse> => {
    const res = await fetch(`${BACKEND_BASE}/api/auth/tokens`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name }),
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to create token');
    return res.json();
  },

  list: async (): Promise<{ tokens: ApiTokenInfo[] }> => {
    const res = await fetch(`${BACKEND_BASE}/api/auth/tokens`, { credentials: 'include' });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to list tokens');
    return res.json();
  },

  revoke: async (id: string): Promise<{ success: boolean }> => {
    const res = await fetch(`${BACKEND_BASE}/api/auth/tokens/${encodeURIComponent(id)}`, {
      method: 'DELETE',
      credentials: 'include',
    });
    if (!res.ok) throw new Error((await res.json()).detail || 'Failed to revoke token');
    return res.json();
  },
};

export default tokenService;
